export function qrcodeUrl(url: string) {
  const qrcodeUrlPrefix = process.env.NEXT_PUBLIC_QRCODE_URL_PREFIX;
  if (!qrcodeUrlPrefix) {
    throw new Error('QRCODE_URL_PREFIX is not defined');
  }
  return `${qrcodeUrlPrefix}${encodeURIComponent(url)}`;
}
